import { BaseResponse } from '../../../../../types/api/api.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../utils/api/endpoints/consultationsEndpoints';

const PREFIX = '[addPrestationsQuery]';

export const ADD_PRESTATIONS_QUERY_KEY = 'ADD_PRESTATIONS';

export const queryAddPrestations = async (
  consultationId: number,
  items: FormData
) => {
  console.log(PREFIX, `Creating consultations prestations...`);
  const response = await CONSULTATIONS_ENDPOINTS.addPrestations(consultationId, items);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Created consultations prestations.`);
  return json as BaseResponse;
};
